import { produce } from 'immer'
import { closeAccountRouteProps } from 'src/navigation/routeProps'
import {
  PUT_CLOSE_ACCOUNT_FAILURE,
  PUT_CLOSE_ACCOUNT_INIT,
  PUT_CLOSE_ACCOUNT_SUCCESS,
  PutCloseAccountActions,
} from 'src/redux/actions/data/creditCards.actions'
import { createFlyoutReducer } from 'src/redux/genericReducers'
import { parseBackendErrors } from 'src/utils/error.utils'

export interface CloseAccountContentState {
  puttingCloseAccount: boolean
  topLevelError?: string
}

export const initialState: CloseAccountContentState = {
  puttingCloseAccount: false,
}

export type Actions = PutCloseAccountActions

const CoreCloseAccountReducer = (
  state = initialState,
  action: Actions,
): CloseAccountContentState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case PUT_CLOSE_ACCOUNT_INIT: {
        draft.puttingCloseAccount = true
        draft.topLevelError = undefined
        return draft
      }

      case PUT_CLOSE_ACCOUNT_FAILURE: {
        draft.puttingCloseAccount = false
        const errors = parseBackendErrors(action.payload)
        draft.topLevelError = errors.topLevelError
        return draft
      }

      case PUT_CLOSE_ACCOUNT_SUCCESS: {
        draft.puttingCloseAccount = false
        return draft
      }
    }
  })
}

const CloseAccountContentReducer = createFlyoutReducer(
  closeAccountRouteProps,
  initialState,
  CoreCloseAccountReducer,
)

export default CloseAccountContentReducer
